import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getReviewProjects = api(async function reviewProjects() {
    return query(
        gql`
            query ReviewProjects {
                reviewProjects {
                    id
                    title
                    description
                    status
                    documentCount
                    scheduleCount
                    createdAt
                    modifiedAt
                }
            }
        `,
        {},
        { returns: "reviewProjects" }
    )
})
